<template>
  <Transition name="fade">
    <SiteNav v-if="$beet.isReady" />
  </Transition>
  <router-view v-slot="{ Component }">
    <Transition name="fade">
      <component v-if="$beet.isReady" :is="Component" />
    </Transition>
  </router-view>
  <Transition name="fade">
    <div v-if="$beet.isReady">
      <Footer />
      <Gdpr :options="{ backgroundColor: '#ffffff', color: '#032d59' }" />
      <FamilyTransition />
    </div>
  </Transition>
  <Transition name="fade">
    <IntersiteNav v-if="$beet.isReady" />
  </Transition>
  <VideoModal />
</template>

<script>
import SiteNav from '@/components/blocks/SiteNav.vue'
import FamilyTransition from '@/components/FamilyTransition.vue'
import Gdpr from '@/components/gdpr/Gdpr.vue'
import Footer from '@/components/sections/Footer.vue'
import { useLangRouter } from '@/extensions/langRouter'

import IntersiteNav from './components/blocks/IntersiteNav.vue'
import VideoModal from './components/blocks/VideoModal.vue'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  components: { FamilyTransition, Footer, Gdpr, SiteNav, IntersiteNav, VideoModal },
  mounted() {
    window.setTimeout(() => {
      if (this.$route.hash)
        document
          .getElementById(this.$route.hash.replace('#', ''))
          ?.scrollIntoView({ behavior: 'smooth' })
    }, 1000)
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
}
</script>
